import React from 'react';

export const QrIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none">
        <path d="M0 11.1664H10.6667V0.499756H0V11.1664ZM2.66667 3.16642H8V8.49976H2.66667V3.16642Z" fill="white" />
        <path d="M0 24.4994H10.6667V13.8328H0V24.4994ZM2.66667 16.4994H8V21.8328H2.66667V16.4994Z" fill="white" />
        <path d="M13.3333 0.499756V11.1664H23.9999V0.499756H13.3333ZM21.3333 8.49976H15.9999V3.16642H21.3333V8.49976Z" fill="white" />
        <path d="M23.9999 21.8335H21.3333V24.5002H23.9999V21.8335Z" fill="white" />
        <path d="M15.9999 13.8328H13.3333V16.4994H15.9999V13.8328Z" fill="white" />
        <path d="M18.6667 16.5H16V19.1667H18.6667V16.5Z" fill="white" />
        <path d="M15.9999 19.1663H13.3333V21.8329H15.9999V19.1663Z" fill="white" />
        <path d="M18.6667 21.8335H16V24.5002H18.6667V21.8335Z" fill="white" />
        <path d="M21.3334 19.1663H18.6667V21.8329H21.3334V19.1663Z" fill="white" />
        <path d="M21.3334 13.8328H18.6667V16.4994H21.3334V13.8328Z" fill="white" />
        <path d="M23.9999 16.5H21.3333V19.1667H23.9999V16.5Z" fill="white" />
    </svg>
);
